import {Fillable, Path, PrimaryKey, RestModel} from 'ng-rest-model';
import {HasId} from '../../shared/interfaces';
import {Timestamped} from '../../shared/interfaces';

@Path('series')
export class Series extends RestModel implements HasId, Timestamped {
    private static _storedForNext: Series;

    static storeForNext(series: Series): void {
        this._storedForNext = series;
    }

    static loadForNext(): Series {
        const series = Series._storedForNext;
        Series._storedForNext = null;
        return series;
    }

    @PrimaryKey()
    id: number;

    @Fillable()
    title: string;

    @Fillable()
    when: string;

    created_at: string;
    updated_at: string;

    storeForNext(): void {
        Series._storedForNext = this;
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/sermons/classes/series.ts